import i18next from 'i18next';

export const formatNumber = (
  value: string | number,
  locale?: string,
): string => {
  const languages = locale || i18next.languages;

  let valueToFormat;
  if (typeof value == 'number') {
    valueToFormat = value;
  } else if (!isNaN(parseInt(value))) {
    valueToFormat = parseInt(value);
  }

  if (valueToFormat) {
    try {
      return new Intl.NumberFormat(languages).format(valueToFormat);
    } catch (e) {
      return value.toString();
    }
  }
  return value.toString();
};
